module.exports = __webpack_public_path__ + "img/total_desktop.61962d70.png";